const navigationConfig = [];

export default navigationConfig;
